import React, { useEffect, useState } from 'react';

const DeliveryCountdown = ({ expressDeliveryTimeISO }) => {
    const [now, setNow] = useState(new Date());
    const [targetTime, setTargetTime] = useState(null);
    const [isSameDay, setIsSameDay] = useState(true);

    useEffect(() => {
        const timer = setInterval(() => {
            setNow(new Date());
        }, 1000);

        return () => clearInterval(timer);
    }, []);

    useEffect(() => {
        if (!expressDeliveryTimeISO) return;

        const expressTime = new Date(expressDeliveryTimeISO);
        const targetToday = new Date();
        targetToday.setHours(
            expressTime.getUTCHours(),
            expressTime.getUTCMinutes(),
            expressTime.getUTCSeconds(),
            0
        );

        if (now < targetToday) {
            setTargetTime(targetToday);
            setIsSameDay(true);
        } else {
            let nextDay = new Date(now);
            do {
                nextDay.setDate(nextDay.getDate() + 1);
            } while (nextDay.getDay() === 0 || nextDay.getDay() === 6); 

            nextDay.setHours(
                expressTime.getUTCHours(),
                expressTime.getUTCMinutes(),
                expressTime.getUTCSeconds(),
                0
            );

            setTargetTime(nextDay);
            setIsSameDay(false);
        }
    }, [expressDeliveryTimeISO, now]);

    if (!targetTime) return null;

    const diffMs = targetTime - now;
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

    const label = isSameDay
        ? 'Versand heute'
        : 'Versand am nächsten Werktag';

    return (
        <div
            className="uk-margin-small-bottom uk-text-medium uk-flex uk-flex-wrap uk-flex-row uk-flex-column@s"
            style={{ lineHeight: '1.4' }}
            role="group"
            aria-labelledby="versandLabel"
        >
            <div id="versandLabel"><strong>{label}</strong> bei Bestellung innerhalb&nbsp;</div>
            <div
                style={{ fontWeight: 'bold', color: diffHours < 1 ? '#E80026' : '#128001'  }}
                aria-live="polite"
                aria-label="Verbleibende Zeit bis zur Versandfrist"
            >
                {diffHours} Std. {diffMinutes.toString().padStart(2, '0')} Min.
            </div>
        </div>
    );
};

export default DeliveryCountdown;
